export type AccountLogoFetchedPayload = {
	dataUrl: string | null;
};

export type AccountLogoFetchedAction = {
	type: 'ACCOUNT_LOGO_FETCHED';
	payload: AccountLogoFetchedPayload;
	accountId: number;
};

export default (payload: AccountLogoFetchedPayload, accountId: number): AccountLogoFetchedAction => ({
	type: 'ACCOUNT_LOGO_FETCHED',
	payload,
	accountId,
});
